const SONGBIRD_INTEGRITY_BY_URL: Record<string, string> = {
  'https://cas.static.client.cardinaltrusted.com/songbird/v2.1.3/songbird.js':
    'sha384-WllJleM4xfVYLyRUgxxtAAPgfD5U3ursxM52cfjCyEEmRq1prDGuHVQykhNFIgkb',
  'https://static.client.cardinaltrusted.com/songbird/v2.1.3/songbird.js':
    'sha384-4J+dXfEI8CVL8+Pl7r2nOaMWFTrYWFi/txuo4IAnfi53TVaQ/IhoLTEOomXzLQIH',
};

export const SONGBIRD_TEST_URL = 'https://cas.static.client.cardinaltrusted.com/songbird/v2.1.3/songbird.js';
export const SONGBIRD_LIVE_URL = 'https://static.client.cardinaltrusted.com/songbird/v2.1.3/songbird.js';

export const getSongbirdIntegrity = (url?: string): string | undefined =>
  url ? SONGBIRD_INTEGRITY_BY_URL[url] : undefined;
